import { Box, useBreakpointValue } from '@chakra-ui/react';
import { Text } from 'components/ui';
import { chipStyles } from 'components/ui/chip';

/**
 * Presentational chip used by the symptom, condition and identity screens.
 *
 * Visuals come from `chipStyles` so this stays in step with the interactive
 * `Chip`. It stays a `Box` rather than delegating to `Chip` because every
 * call site already wraps it in a `Pressable`, and a button inside a button
 * is invalid markup.
 */
export const Pill = ({ isSelected, text }) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  });

  return (
    <Box
      {...chipStyles(!!isSelected)}
      display="flex"
      alignItems="center"
      justifyContent="center"
      maxW={isMobile ? '300px' : 'none'}
    >
      <Text
        truncate
        color="inherit"
        fontSize="sm"
        fontWeight={400}
        lineHeight="1.25"
        letterSpacing="0.01em"
      >
        {text}
      </Text>
    </Box>
  );
};
